import React from "react";
import { Box, Button, Text } from "grommet";
import GazetteBook from "./GazetteBook";
import {
    BsChevronBarContract,
    BsChevronBarExpand,
    BsChevronContract,
    BsChevronExpand,
} from "react-icons/bs";

const GazetteYearMonth = (props: any) => {
    const { yrmo, books } = props;
    const [bookList, setBookList] = React.useState<any>([]);

    React.useEffect(() => {
        console.log("yrmo", yrmo);
        console.log("books", books);
        setBookList(books);
    }, [yrmo, books])

    const BookList = () => {
        console.log("book list", books);
        return (
            <Box height="full" flex={false} overflow={"auto"}>
                {bookList.map((b: any, index: number) => {
                    return (
                        <Box
                            key={index}
                            flex={false}
                            direction="row"
                            align="start"
                            justify="start"
                            margin="5px"
                        >
                            <BookUnit
                                abook={b}
                                open={index === 0 ? true : false}
                            />
                        </Box>
                    );
                })}
            </Box>
        );
    };

    const BookUnit = (props: any) => {
        const openBook = props.open;
        const aBook = props.abook;
        const [open, setOpen] = React.useState(false);

        React.useEffect(() => {
            setOpen(openBook);
        }, []);

        return (
            <Box
                height="full"
                margin={{ horizontal: "10px"}}
                width="98%"
                flex={false}
            >
                <Box direction="row" align="center" margin={{top:'10px'}}>
                    <Text size="15px" color="grey" margin={{ right: "10px" }}>
                        {aBook.book_title}
                    </Text>
                    <Text size="15px" weight="bold" margin={{ right: "10px" }}>
                        {aBook.numeration}
                    </Text>
                    <Text size="15px" color="rgb(100,100,100)">
                        {aBook.publish_date}
                    </Text>
                    {/* <Text size="15px" color="rgb(100,100,100)">
                        {selectedBook.book_id}
                    </Text> */}
                    <Button
                        margin={{ left: "20px" }}
                        plain
                        icon={
                            open ? (
                                <BsChevronContract size="15px" />
                            ) : (
                                <BsChevronExpand size="15px" />
                            )
                        }
                        onClick={() => {
                            setOpen(!open);
                        }}
                    />
                </Box>
                {open && (
                    <Box align='center'
                        width="full" flex={false} margin="5px" pad="10px">
                        <GazetteBook bookid={aBook.book_id} />
                    </Box>
                )}
            </Box>
        );
    };
    return <><BookList/></>;
};

export default GazetteYearMonth;
